export default __webpack_public_path__ + "static/media/Belt of Necrotic Dread.1c719f57.jpg";